var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.756 5.2519H2.1911V3.57378C2.1911 1.56941 3.63622 0 5.70304 0C7.7698 0 9.1839 1.60043 9.1839 3.57378V5.23642H9.619C10.5824 5.23642 11.3594 6.01333 11.375 6.99226V12.2442C11.375 13.2075 10.598 13.9844 9.619 14H1.756C0.792573 14 0.0155954 13.2231 0 12.2442V6.99198C0 6.02864 0.792573 5.2519 1.756 5.2519ZM8.31368 5.2519V3.57378C8.31368 2.08206 7.28805 0.87011 5.7031 0.87011C4.13363 0.87011 3.0614 2.05098 3.0614 3.57378V5.23642L8.31377 5.23631L8.31368 5.2519ZM0.885782 12.2441C0.885782 12.7257 1.27427 13.1142 1.75597 13.1142H9.61898C10.1007 13.1142 10.4892 12.7257 10.4892 12.2441V6.99217C10.4892 6.51052 10.1007 6.12207 9.61898 6.12207H1.75597C1.27427 6.12207 0.885782 6.51052 0.885782 6.99217V12.2441ZM4.81729 8.74799C4.81729 9.07435 4.98823 9.35398 5.25239 9.50939V10.9389C5.25239 11.1875 5.45444 11.374 5.6875 11.374C5.93616 11.374 6.12261 11.1719 6.12261 10.9389V9.50939C6.38677 9.35396 6.55771 9.07432 6.55771 8.74799C6.55771 8.26633 6.16923 7.87788 5.68753 7.87788C5.20583 7.86227 4.81729 8.25074 4.81729 8.74799Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.362704fd3d3c8579fdd86bceae9d1bf1.svg";
export { ForwardRef as ReactComponent };